module.exports = "/images/google_app_store.png?bd2befc93a270646136a7408b13e39c6";